import { Link } from 'react-router-dom';
import './MuhuratLink.scss'; // You'll create a corresponding SCSS file

const muhuratLinks = [
  { title: "Chogadiya", path: "/muhurat/chogadiya" },
  { title: "Subha Hora", path: "/muhurat/subho-hora" },
  { title: "Vivah Muhurat", path: "/muhurat/vivah-muhurat" },
  { title: "Griha Pravesh", path: "/muhurat/griha-pravesh" },
  { title: "Property Purchase", path: "/muhurat/property-purchase" },
  { title: "Vehicle Purchase", path: "/muhurat/vehicle-purchase" },
  { title: "Lagna Table", path: "/muhurat/lagna-table" },
  { title: "Gowri Panchangam", path: "/muhurat/gowri-panchangam" },
  { title: "Jain Pachchakkan", path: "/muhurat/jain-pachchakkan" },
  { title: "Rahu Kala", path: "/muhurat/rahu-kala" },
  { title: "Auspicious Yoga", path: "/muhurat/auspicious-yoga" },
  { title: "Punchake Rahita", path: "/muhurat/punchake-rahita" },
  { title: "Abhijit Muhurat", path: "/muhurat/abhijit-muhurat" },
  { title: "Do Ghati Muhurat", path: "/muhurat/do-ghati-muhurat" },
  { title: "Subha Dates", path: "/muhurat/subha-dates" },
];

const MuhuratLink = () => {
  return (
    <div className="muhurat-link-container">
      <h2 className="muhurat-link-title">Muhurats</h2>
      <div className="muhurat-link-grid">
        {muhuratLinks.map((item, index) => (
          <Link key={index} to={item.path} className="muhurat-link-item">
            <img src="https://vedastro.in/assets/img/Shubh-Muhurat-2019-ofu9uz3xye87o2tcrivsbvg656yq622r8mq5hdanwo.jpg" alt="muhurat" />
            {item.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MuhuratLink;
